// extracted by mini-css-extract-plugin
module.exports = {"specialInformation":"SpecialInfo_specialInformation__7gDz_"};